//dynamically updates header background color transition with scroll

module.exports = function() {
  window.addEventListener('scroll', function() {
    if(document.documentElement.scrollTop > 0 &&
        document.querySelectorAll('body.documentation').length === 0 &&
        document.querySelectorAll('body.xf-body').length === 0) {
        document.querySelector('.sw-dms-nav__desktop').classList.add('sw--header-scroll');
        document.querySelectorAll('.sw--header-transparent').forEach(el => {
            el.classList.remove('sw--header-transparent');
            el.classList.add('sw--header-transparent-off');
        });
        document.querySelectorAll('.sw-dms-nav__link--light').forEach(el => {
            el.classList.remove('sw-dms-nav__link--light');
            el.classList.add('sw-dms-nav__link--light-off');
        });
        document.querySelectorAll('.sw-dms-button--transparent').forEach(el => {
            el.classList.remove('sw-dms-button--transparent');
            el.classList.add('sw-dms-button--transparent-off');
        });
    } else {
        document.querySelector('.sw-dms-nav__desktop').classList.remove('sw--header-scroll');
        document.querySelectorAll('.sw--header-transparent-off').forEach(el => {
            el.classList.remove('sw--header-transparent-off');
            el.classList.add('sw--header-transparent');
        });
        document.querySelectorAll('.sw-dms-nav__link--light-off').forEach(el => {
            el.classList.remove('sw-dms-nav__link--light-off');
            el.classList.add('sw-dms-nav__link--light');
        });
        document.querySelectorAll('.sw-dms-button--transparent-off').forEach(el => {
            el.classList.remove('sw-dms-button--transparent-off');
            el.classList.add('sw-dms-button--transparent');
        });
    }
  });

  window.addEventListener('DOMContentLoaded', function() {
      if (document.querySelectorAll('body.xf-body').length > 0) {
          document.querySelector('.sw-dms-nav__desktop').classList.remove('sw--position-fixed');
          document.querySelector('.sw-dms-nav__desktop').classList.add('sw--position-relative');
      }

      if (document.querySelectorAll('.myshapeways-account').length > 0) {
          document.querySelector('.sw-dms-nav__mob').classList.add('account-header');
      }
      if (document.querySelectorAll('.sct-settings').length > 0) {
          document.querySelector('.sw-dms-nav__mob').classList.add('settings-header');
      }
      if (document.querySelectorAll('.sw-model-material-configurator-layout').length > 0) {
          document.querySelector('.primary-content-container').classList.remove('sw--content-block');
      }
  }, true);
};
